module.exports = __webpack_public_path__ + "img/58af657.jpg";